import type { Resource } from '../../';
export const general_backToTop: Resource = {"default":"Back to top"};
